// Author thq
// Date 2021-10-22 10:11:07

class EmAdmOrganization {
constructor({
        id = null,
        sid = '',
        parentNcId = '',
        pkGroup = '',
        code = '',
        name = '',
        parentId = '',
        level = '',
        nodeCode = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.sid = sid;
    this.parentNcId = parentNcId;
    this.pkGroup = pkGroup;
    this.code = code;
    this.name = name;
    this.parentId = parentId;
    this.level = level;
    this.nodeCode = nodeCode;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new EmAdmOrganization();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.emAdmOrganization.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'sid',
        label: 'label.em.admin.emAdmOrganization.grid.sid',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentNcId',
        label: 'label.em.admin.emAdmOrganization.grid.parentNcId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'pkGroup',
        label: 'label.em.admin.emAdmOrganization.grid.pkGroup',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.em.admin.emAdmOrganization.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.admin.emAdmOrganization.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentId',
        label: 'label.em.admin.emAdmOrganization.grid.parentId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.em.admin.emAdmOrganization.grid.level',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.em.admin.emAdmOrganization.grid.nodeCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.em.admin.emAdmOrganization.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAdmOrganization.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    sidFilter : '',
    parentNcIdFilter : '',
    pkGroupFilter : '',
    codeFilter : '',
    nameFilter : '',
    parentIdFilter : '',
    levelFilter : '',
    nodeCodeFilter : '',
    seqFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'sidFilter',
        label: 'label.em.admin.emAdmOrganization.filter.sid',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentNcIdFilter',
        label: 'label.em.admin.emAdmOrganization.filter.parentNcId',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'pkGroupFilter',
        label: 'label.em.admin.emAdmOrganization.filter.pkGroup',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.em.admin.emAdmOrganization.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.admin.emAdmOrganization.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentIdFilter',
        label: 'label.em.admin.emAdmOrganization.filter.parentId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'levelFilter',
        label: 'label.em.admin.emAdmOrganization.filter.level',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nodeCodeFilter',
        label: 'label.em.admin.emAdmOrganization.filter.nodeCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seqFilter',
        label: 'label.em.admin.emAdmOrganization.filter.seq',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'sid',
        label: 'label.em.admin.emAdmOrganization.entity.sid',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentNcId',
        label: 'label.em.admin.emAdmOrganization.entity.parentNcId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'pkGroup',
        label: 'label.em.admin.emAdmOrganization.entity.pkGroup',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'code',
        label: 'label.em.admin.emAdmOrganization.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.em.admin.emAdmOrganization.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentId',
        label: 'label.em.admin.emAdmOrganization.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'level',
        label: 'label.em.admin.emAdmOrganization.entity.level',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nodeCode',
        label: 'label.em.admin.emAdmOrganization.entity.nodeCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seq',
        label: 'label.em.admin.emAdmOrganization.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.emAdmOrganization.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmAdmOrganization, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
